
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"37","height":"38","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill-rule":"nonzero","fill":"none"}},[_c('path',{attrs:{"d":"M20.868 2.45c-.41-.223-.814-.199-1.212.073L7.683 11.875h-3.99c-1.02 0-1.89.31-2.611.928C.36 13.42 0 14.176 0 15.066l.075 7.83c0 .891.36 1.652 1.081 2.283.721.63 1.592.946 2.611.946h3.954l11.935 9.352a1.115 1.115 0 00.634.222c.2 0 .386-.05.56-.148.423-.223.634-.57.634-1.04V3.489c0-.47-.205-.816-.616-1.039zm-1.771 29.835l-10.332-8.35a1.245 1.245 0 00-.671-.185H3.767c-.373 0-.684-.087-.932-.26-.249-.173-.373-.37-.373-.594l-.075-7.83c0-.198.124-.383.373-.556.249-.173.56-.26.933-.26h4.326c.249 0 .473-.074.672-.223l10.406-8.312v26.57zm13.651-13.248l3.916-3.933c.224-.248.336-.532.336-.854 0-.322-.118-.6-.354-.835a1.15 1.15 0 00-.84-.352c-.323 0-.609.11-.857.333l-3.88 3.934-3.878-3.934a1.248 1.248 0 00-.858-.334 1.15 1.15 0 00-.84.353 1.138 1.138 0 00-.354.835c0 .322.112.606.336.854l3.916 3.933-3.879 3.86-.15.222-.111.241-.056.26v.26l.056.26.112.24.15.224c.248.222.534.334.857.334.323 0 .61-.112.858-.334l3.842-3.897 3.841 3.897c.249.222.535.334.858.334.323 0 .603-.118.84-.353.236-.235.354-.513.354-.835 0-.322-.112-.606-.336-.854l-3.879-3.859z","fill":"#FFF"}}),_c('path',{attrs:{"d":"M0 0h37v38H0z"}})])])
          )
        }
      }
    